export enum UserFeedComputedStatus {
  Ok = "OK",
  RequiresAttention = "REQUIRES_ATTENTION",
  ManuallyDisabled = "MANUALLY_DISABLED",
  FeedLimitExceeded = "FEED_LIMIT_EXCEEDED",
  Retrying = "RETRYING",
}
